export default {
  bind(el, binding) {
    el.addEventListener('touchstart', function (event) {
      event.stopPropagation();
      el.classList.add(binding.value || 'touch-scale');
    });
    el.addEventListener('touchend', function (event) {
      event.stopPropagation();
      el.classList.remove(binding.value || 'touch-scale');
    });
  }
};
